module.exports = __webpack_public_path__ + "static/media/Server Hardening.08cd6501.png";